import { render, staticRenderFns } from "./MitraBaznas.vue?vue&type=template&id=e431bbf8"
import script from "./MitraBaznas.vue?vue&type=script&lang=js"
export * from "./MitraBaznas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports